module.exports = __webpack_public_path__ + "img/Objectives.3c73b0cb.svg";